import React from "react";
import {
  Button,
  Paper,
  TextField,
  MenuItem,
  Grid,
  Autocomplete,
} from "@mui/material";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import Iconify from "../../../../components/Iconify";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { es } from "date-fns/locale";
import { useFormik } from "formik";
import {
  CREAR_MOV_BANCARIOS,
  LISTAR_MOV_BANCARIOS,
  LISTAR_SUBTIPO_EGRESO,
} from "../../../../graphql/bancos";
import { useEffect } from "react";
import { useState } from "react";
const FrmAgregarMovimiento = ({
  setOpenDialog,
  setOpenSnackBar,
  setErrorGraph,
  id,
}) => {
  const [tipoConceptoId, setTipoConceptoId] = useState(1);
 
  const [agregarMovBancario] = useMutation(CREAR_MOV_BANCARIOS, {
    update(cache, { data: { agregarMovBancario } }) {
      const { listarMovimientosBancarios } = cache.readQuery({
        query: LISTAR_MOV_BANCARIOS,
        variables: { id: id },
      });
      cache.writeQuery({
        query: LISTAR_MOV_BANCARIOS,
        data: {
          listarMovimientosBancarios: [
            ...listarMovimientosBancarios,
            agregarMovBancario,
          ],
        },
      });
    },
  });
  const [obtenerConceptoBanco, { loading, data, error: e }] = useLazyQuery(
    LISTAR_SUBTIPO_EGRESO,
    {
      variables: {
        id: "1",
      },
    }
  );
  const { refetch } = useQuery(LISTAR_MOV_BANCARIOS, {
    variables: {
      id: id,
    },
  });

  useEffect( () => {
     obtenerConceptoBanco({
      variables: {
        id: 1,
      },
    });
  }, []);

  const formik = useFormik({
    initialValues: {
      noOperacion: "",
      operacion: "",
      tipoOperacion: "", //1 Ingreso 2 Egreso
      subtipoOperacion: "",
      montoOperacion: "",
      fechaOperacion: "",
      cuentaId: id,
      TipoConceptoId: "", //Los subtipos de cuenta
    },
    onSubmit: async (input) => {
      try {
        const result = await agregarMovBancario({
          variables: {
            input: {
              noOperacion: input.noOperacion,
              operacion: input.operacion,
              tipoOperacion: parseInt(input.tipoOperacion),
              subtipoOperacion: parseInt(input.subtipoOperacion),
              montoOperacion: parseFloat(input.montoOperacion),
              fechaOperacion: input.fechaOperacion,
              cuentaId: parseInt(input.cuentaId),
            },
          },
        });
        setOpenSnackBar(true);
        setErrorGraph({
          mensaje: result.data.agregarMovBancario,
          severity: "success",
        });
        //Si todo sale bien reseteamos el formulario
        refetch();
        formik.resetForm();
      } catch (error) {
        setOpenSnackBar(true);
        setErrorGraph({ mensaje: error.message, severity: "error" });
      }
    },
  });

  useEffect(() => {
    if (formik.values.tipoOperacion == "") {
      setTipoConceptoId(1);
    } else {
      setTipoConceptoId(formik.values.tipoOperacion);
    }
    obtenerConceptoBanco({
      variables: {
        id: tipoConceptoId,
      },
    });
  }, [tipoConceptoId, setTipoConceptoId, formik.values.tipoOperacion]);

  const handleOpenDialog = () => {
    setOpenDialog(false);
    //setOpenSnackBar(true);
  };

  // Para seleccionar el tipo de egreso
  if (loading || data == undefined) {
    return <h1>....</h1>;
  } else {
    console.log(data.obtenerConceptoBanco);

    return (
      <form onSubmit={formik.handleSubmit}>
        <Paper style={{ padding: 10 }}>
          <Grid container alignItems="flex-start" spacing={3}>
            <Grid item xs={12} md={12} lg={12}>
              <TextField
                label="Operación"
                variant="standard"
                fullWidth
                id="operacion"
                value={formik.values.operacion}
                onChange={formik.handleChange}
              />
            </Grid>
            {/* <Grid item xs={12} md={12} lg={6}>
            <TextField
              label="No. de Operación"
              variant="standard"
              fullWidth
              id="noOperacion"
              value={formik.values.noOperacion}
              onChange={formik.handleChange}
            />
          </Grid> */}
            <Grid item xs={12} md={12} lg={6}>
              <TextField
                select
                fullWidth
                name="tipoOperacion"
                id="tipoOperacion"
                label="Tipo de Operación"
                variant="standard"
                onChange={formik.handleChange}
                value={formik.values.tipoOperacion}
              >
                <MenuItem value="1">Ingreso</MenuItem>
                <MenuItem value="2">Egreso</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12} md={12} lg={6}>
              <TextField
                select
                fullWidth
                name="subtipoOperacion"
                id="subtipoOperacion"
                label="Subtipo de Operación"
                variant="standard"
                onChange={formik.handleChange}
                value={formik.values.subtipoOperacion}
              >
                {data.obtenerConceptoBanco.map((options) => (
                  <MenuItem key={options.id} value={options.id}>
                    {options.id} - {options.concepto}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} md={12} lg={6}>
              <TextField
                label="Monto"
                variant="standard"
                fullWidth
                id="montoOperacion"
                value={formik.values.montoOperacion}
                onChange={formik.handleChange}
              />
            </Grid>
            <Grid item xs={12} md={12} lg={6}>
              <LocalizationProvider
                adapterLocale={es}
                dateAdapter={AdapterDateFns}
              >
                <DatePicker
                  onChange={(date) =>
                    formik.setFieldValue("fechaOperacion", date)
                  }
                  value={formik.values.fechaOperacion}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      variant="standard"
                      label="Fecha de Operación"
                      id="fechaOperacion"
                      // value={formik.values.fechaOperacion}
                      // onChange={formik.handleChange}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>
          </Grid>
          <Grid item xs={12} md={12} lg={6}>
            <Button
              type="submit"
              startIcon={<Iconify icon="eva:save-outline" />}
            >
              Guardar
            </Button>
            <Button
              color="error"
              startIcon={<Iconify icon="eva:close-outline" />}
              onClick={() => handleOpenDialog()}
            >
              Cerrar
            </Button>
          </Grid>
        </Paper>
      </form>
    );
  }
};

export default FrmAgregarMovimiento;
